import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { notificationService } from '../api';
import './NotificationsList.css';

const TYPE_ICONS = {
    0: '🔔', // System
    1: '🚫', // AdBlocked
    2: '✅', // ReportDismissed
    3: '💰', // PriceChanged
};

const NotificationsList = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(() => {
        setLoading(true);
        setError(null);
        notificationService.getNotifications()
            .then(({ data }) => setItems(data))
            .catch(() => setError('Не удалось загрузить уведомления.'))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => { load(); }, [load]);

    const markAsRead = async (id) => {
        setItems(prev => prev.map(n => n.id === id ? { ...n, isRead: true } : n));
        try { await notificationService.markAsRead(id); } catch { /* ignore */ }
    };

    const markAllAsRead = async () => {
        setItems(prev => prev.map(n => ({ ...n, isRead: true })));
        try { await notificationService.markAllAsRead(); } catch { /* ignore */ }
    };

    if (loading) return <div className="profile-content__placeholder">Загрузка...</div>;
    if (error) return <div className="profile-content__placeholder">{error}</div>;
    if (items.length === 0) return <div className="profile-content__placeholder">У вас пока нет уведомлений.</div>;

    const hasUnread = items.some(n => !n.isRead);

    return (
        <div className="notifications-list">
            {hasUnread && (
                <button className="notifications-list__mark-all" onClick={markAllAsRead}>
                    Отметить все как прочитанные
                </button>
            )}

            {items.map(n => {
                const content = (
                    <div
                        className={`notifications-list__item${n.isRead ? '' : ' notifications-list__item--unread'}`}
                        onClick={() => !n.isRead && markAsRead(n.id)}
                    >
                        <span className="notifications-list__icon">{TYPE_ICONS[n.type] ?? '🔔'}</span>
                        <div className="notifications-list__body">
                            <div className="notifications-list__title">{n.title}</div>
                            <div className="notifications-list__message">{n.message}</div>
                            <div className="notifications-list__date">
                                {new Date(n.createdAt).toLocaleString('ru-RU')}
                            </div>
                        </div>
                    </div>
                );

                return n.relatedAdId ? (
                    <Link key={n.id} to={`/ad/${n.relatedAdId}`} className="notifications-list__link">
                        {content}
                    </Link>
                ) : (
                    <div key={n.id}>{content}</div>
                );
            })}
        </div>
    );
};

export default NotificationsList;
